import React from 'react';
import { Box } from '@chakra-ui/react';
import { DOODLE_MASK, DOODLE_TILE } from './doodle';

/**
 * The doodle layer behind a thread.
 *
 * Absolutely positioned inside the scroll container (which must be
 * `position: relative`), so it stays put while messages scroll over it —
 * WhatsApp's wallpaper does not move with the conversation. It paints the
 * `wa.doodle` token through the pattern mask; see `wallpaper.js` for why that
 * is a mask and not an image. `pointerEvents: none` so it never steals a click.
 */
export default function Wallpaper() {
	return (
		<Box
			aria-hidden="true"
			position="absolute"
			inset="0"
			bg="wa.doodle"
			pointerEvents="none"
			sx={{
				maskImage: DOODLE_MASK,
				WebkitMaskImage: DOODLE_MASK,
				maskRepeat: 'repeat',
				WebkitMaskRepeat: 'repeat',
				maskSize: DOODLE_TILE,
				WebkitMaskSize: DOODLE_TILE,
			}}
		/>
	);
}
